//
// Javascript for the DateEdit input control
//
//  Matt Brown
//
//  Moved to external js file - Ben Ramey, Feb 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.DateEdit = function (inputs)
{
  inputs = inputs || $('input[type=text].fastdatepicker');
  inputs.each(function ()
  {
    var options = $.extend(HEIJS.Controls.DateEdit.options, {
      yearRange: $(this).attr("yearrange") ? $(this).attr("yearrange") : "c-10:c+10"
    });
    $(this).fastDatePicker(options);
  });
};

HEIJS.Controls.DateEdit.options = {
  showOn: null,
  changeYear: true,
  changeMonth: true,
  duration: 0,
  yearRange: "c-10:c+10",
  gotoCurrent: true,
  dateFormat: "m/d/yy",
  fixFocusIE: false,    
  onSelect: function(dateText, inst) {
    this.fixFocusIE = true;
    $(this).change().focus();
	return undefined;
  },
  onClose: function(dateText, inst) {
    this.fixFocusIE = true;
    this.focus();
	return undefined;
  },
  beforeShow: function(input, inst) {
    var result = $.browser.msie ? !this.fixFocusIE : true;
    this.fixFocusIE = false;
    return result;
  }
};

$(document).ready(function () { new HEIJS.Controls.DateEdit(); });